<template>
  <agile :dots="false" :navButtons="false" :autoplay="true" :autoplay-speed="5000" :speed="1000">
    
    <div class="slide"><img src="img/langoustine2.jpg" alt="Langoustine" /></div>
    <div class="slide"><img src="img/pie2.jpeg" alt="Venison pie" /></div>
    <div class="slide"><img src="img/octopus.jpg" alt="Octopus" /></div>
    <div class="slide"><img src="img/seafood-platter.jpg" alt="Seafood platter" /></div>
    <div class="slide"><img src="img/kelp-salad.jpg" alt="Kelp Salad" /></div>
    <div class="slide"><img src="img/langoustine_crab.jpg" alt="Langoustine and crab" /></div>
  </agile>
</template>

<script>
  export default {
    name: "App",

  };
</script>


